import { InputRef, Modal } from "antd";
import TableComponent from "../../CommonComponent/TableComponent";
import { convertDateFromMillis } from "../../../utils/luxon";
import { DD_MM_YYYY_H_MM } from "../../../utils/app-common";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { filterFunction } from "../../../common/SearchFilterComponent";
import { useCNDNStore } from "../../../stores/CNDNStore";
import { useCreditNoteContextHook } from "./CreditNoteTableComponent";
import React from "react";
import { ColumnType } from "antd/lib/table";

const CreditNoteWaybillHistoryComponent = ({ open, onClose }: { open: boolean, onClose: (value: boolean) => void }) => {

    const searchInput = React.useRef<InputRef>(null);
    const getColumnSearchProps = (dataIndex: string): ColumnType<any> => filterFunction(dataIndex, searchInput);
    const GetCreditNoteWaybillHistoryAction = useCNDNStore(state => state?.GetCreditNoteWaybillHistoryAction);
    const waybillHistory = useCNDNStore(state => state?.waybillHistory);
    const { promiseInProgress: waybillHistoryProgress } = usePromiseTracker({ area: 'waybill-history-area' })

    const { selectedWaybill } = useCreditNoteContextHook();

    React.useEffect(() => {
        trackPromise(GetCreditNoteWaybillHistoryAction(selectedWaybill), 'waybill-history-area');
    }, [GetCreditNoteWaybillHistoryAction, selectedWaybill])

    const columns = React.useMemo(() => [
        {
            title: 'CN Request Number',
            dataIndex: 'cnRequest',
            key: 'cnRequest',
            width: 40,
            ...getColumnSearchProps('cnRequest')
        }, {
            title: 'cn Waybill Number',
            dataIndex: 'cnWaybillNo',
            key: 'cnWaybillNo',
            width: 40,
            ...getColumnSearchProps('cnWaybillNo')
        }, {
            title: 'waybill Number',
            dataIndex: 'waybillNo',
            key: 'waybillNo',
            width: 40,
            ...getColumnSearchProps('waybillNo')
        }, {
            title: 'Amendment Amount',
            dataIndex: 'amendCharge',
            key: 'amendCharge',
            width: 40,
            ...getColumnSearchProps('amendCharge')
        }, {
            title: 'Remark',
            dataIndex: 'remarks',
            key: 'remarks',
            width: 40,
            ...getColumnSearchProps('remarks')
        },
        {
            title: 'Created Date',
            dataIndex: 'createdDate',
            key: 'createdDate',
            width: 40,
            ...getColumnSearchProps('createdDate'),
            render: (createdDate: number) => convertDateFromMillis(createdDate, DD_MM_YYYY_H_MM)
        }, {
            title: 'created By',
            dataIndex: 'createdBy',
            key: 'createdBy',
            width: 40,
            ...getColumnSearchProps('createdBy'),
        }, {
            title: 'updated Date',
            dataIndex: 'updatedDate',
            key: 'updatedDate',
            width: 40,
            ...getColumnSearchProps('updatedDate'),
            render: (updatedDate: number) => convertDateFromMillis(updatedDate, DD_MM_YYYY_H_MM)
        }, {
            title: 'updated By',
            dataIndex: 'updatedBy',
            key: 'updatedBy',
            width: 40,
            ...getColumnSearchProps('updatedBy'),
        }], []);
    return (
        <Modal open={open} onCancel={() => onClose(false)} title={`${selectedWaybill} - History`}
            width={1000} centered okButtonProps={{ style: { display: 'none' } }}>
            <TableComponent data={waybillHistory}
                columns={columns}
                isLoading={waybillHistoryProgress}
                scroll={{ x: 0, y: 0 }}
            />
        </Modal>
    )
}
export default CreditNoteWaybillHistoryComponent